import React, { useMemo } from 'react';
import { useIsMobile } from 'app/hooks/useIsMobile';
import SharedEquipment from './SharedEquipment';
import SharedFleets from './SharedFleets';
import useGetEquipmentData from 'app/hooks/useGetEquipmentData';
import { useNavigate } from 'react-router-dom';
import { ActionsListItem, Fab } from 'app/components/menu';
import { useTranslation } from 'react-i18next';
import './EquipmentAndFleets.less';

function EquipmentAndFleets() {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { sharesData } = useGetEquipmentData();

  const actions = useMemo<ActionsListItem[]>(() => {
    return [
      {
        label: t('shared_equipment_button'),
        action: () => navigate('/access/share-equipment'),
      },
      {
        label: t('shared_fleets_create_button'),
        action: () => navigate('/access/create-fleet'),
      },
      {
        label: t('shared_fleets_share_button'),
        action: () => navigate('/access/share-fleet'),
      },
    ];
  }, [t]);

  return (
    <div className="equipment-and-fleets">
      {isMobile && (
        <Fab buttonClassName="equipment-and-fleets__fab" actions={actions} />
      )}

      <SharedEquipment
        isMobile={isMobile}
        sharedEquipment={sharesData?.equipment ?? []}
      />
      <SharedFleets
        isMobile={isMobile}
        sharedFleets={sharesData?.fleets ?? []}
      />
    </div>
  );
}

export default EquipmentAndFleets;
